'use client';

import { FC, memo } from 'react';

import { Icon, IconTypes } from '@/react/components/core-ui/Icon';
import { useLocaleMessage } from '@/react/hooks/useLocaleMessage';

import S from './styles.base.module.scss';
import { header_utilBar_viewMoreCountries } from "@/lang/__generated__/ahnu/header_utilBar_viewMoreCountries";

const ViewMoreCountriesLabel: FC = memo(() => {
  const [msg] = useLocaleMessage();
  return (
    <>
      <span className={S.countryIcon}>
        <Icon icon={IconTypes.Globe} />
      </span>
      {msg(header_utilBar_viewMoreCountries)}
    </>
  );
});

/**
 * Renders the view more countries link.
 */
export const ViewMoreCountries: FC = () => {
  return (
    <div className={S.viewMoreCountries}>
      <ViewMoreCountriesLabel />
    </div>
  );
};
